/*
  Component: Footer — mobile accordion
  Responsibility: turn the footer's menu columns into accordions, and keep each toggle's
                  aria-expanded honest.

  Progressive enhancement, in that order:

    1. The markup renders open — every panel visible, every toggle button hidden.
    2. This file marks the footer as enhanced, which is the hook the stylesheet needs
       before it will collapse anything or show a toggle.
    3. Only then does a click do something.

  So a footer this file never reaches is a plain stack of headings and links. Nothing is
  unreachable and there is no button on screen that does nothing.

  There is no breakpoint in here. Whether a column may collapse at all is a question
  about layout, and the stylesheet answers it — on desktop the toggles are display: none
  and the panels are open regardless of the state class below. That is also why a column
  left open on a phone survives a resize without needing to be reset from here.
*/

function initFooterColumn(column) {
  const toggle = column.querySelector('[data-kl-footer-toggle]');
  const panel = column.querySelector('[data-kl-footer-panel]');

  // Contact and app columns have neither — the design keeps them open at both widths.
  if (!toggle || !panel) return;

  /*
    The markup says expanded because that is the un-enhanced truth. The stylesheet has
    just collapsed the panel, so this is the moment the attribute has to catch up.
  */
  toggle.setAttribute('aria-expanded', 'false');

  toggle.addEventListener('click', () => {
    const isOpen = column.classList.toggle('is-open');

    toggle.setAttribute('aria-expanded', isOpen);
  });
}

function initFooter(footerElement) {
  const columns = footerElement.querySelectorAll('[data-kl-footer-column]');

  if (!columns.length) return;

  /*
    Added before the columns are wired rather than after, so the collapsed styling and
    the aria-expanded each toggle is about to be given land together.
  */
  footerElement.classList.add('is-enhanced');

  columns.forEach(initFooterColumn);
}

document.querySelectorAll('[data-kl-footer]').forEach(initFooter);

// Theme editor: a re-rendered section arrives with fresh, uninitialised markup.
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-kl-footer]').forEach(initFooter);
});
